import Vue from 'vue'
import Firebase from 'firebase'
import './pollyfills'
import VueNotify from 'vue-notifyjs'
import ptBr from 'vee-validate/dist/locale/pt_BR';
import VeeValidate, { Validator } from 'vee-validate';
import lang from 'element-ui/lib/locale/lang/pt-br'
import locale from 'element-ui/lib/locale'
import App from './App.vue'

// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import router from './routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'

import utils from './utils'
import * as JsPDF from 'jspdf'

(function(API){
  API.centerText = function(txt, y) {
    let fontSize = this.internal.getFontSize();
    let pageWidth = this.internal.pageSize.getWidth();
    let txtWidth = (this.getStringUnitWidth(txt) * fontSize) / this.internal.scaleFactor;
    let x = ( pageWidth - txtWidth ) / 2;
    this.text(txt, x, y);
  }
})(JsPDF.API);

// plugin setup
// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize('pt-br', ptBr);
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate)
locale.use(lang)

let app
// Initialize Firebase
const configuration = process.env.FIREBASE_CONFIG

Firebase.initializeApp(configuration)
Firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      el: '#app',
      render: h => h(App),
      router,
      created () {
        Vue.prototype.$utils = utils
        Vue.prototype.$JsPDF = JsPDF
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js